import { useEffect, useRef, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import './Footer.css';

const Footer = () => 
  {
    const scrollRef = useRef();

  useEffect(() => {
    const container = scrollRef.current;
    const scrollAmount = 200;

    const interval = setInterval(() => {
      if (container) {
        const maxScroll = container.scrollWidth - container.clientWidth;

        if (container.scrollLeft + scrollAmount >= maxScroll) {
          container.scrollTo({ left: 0, behavior: "smooth" }); // restart scroll
        } else {
          container.scrollBy({ left: scrollAmount, behavior: "smooth" });
        }
      }
    }, 5000); 

    return () => clearInterval(interval);
  }, []);
  const navigate = useNavigate();
  const [isMobileMenuOpen, setMobileMenuOpen] = useState(false);

  const brands = [
  { name: "Asian spices", img: "/images/brands/asian-spices.png" },
  { name: "Amaravathi", img: "/images/brands/amaravathi.png" },
  { name: "Rohad", img: "/images/brands/rohad.png" },
  { name: "Kadmit", img: "/images/brands/kadmit.png" },
  { name: "Earth touch", img: "/images/brands/earth-touch.png" },
  { name: "Arokiyam", img: "/images/brands/arokiyam.png" },
  { name: "HAKSAYA", img: "/images/brands/haks.jpg" },
  { name: "NALAN", img: "/images/brands/nalan.png" },
  { name: "RRK Groups", img: "/images/brands/ss.png" }
];

  return (
    <div>
      {/* <div className="top-banner">
        <div className="overlay">
          <h1 className="top-title">A Product Of Village Spice House</h1>
          <a href="mailto:info@jeyamfoods.com" className="contact-button">
            Contact Us
          </a>

        </div>
      </div> */}
       <div className="brands-section">
      <h2 className="brands-title">Brand partner's</h2>
      <div className="brands-scroll" ref={scrollRef}>
        {brands.map((brand, index) => (
          <div className="brand-card" key={index}>
            <img src={brand.img} alt={brand.name} className="brand-img" />
            <p className="brand-name">{brand.name}</p>
          </div>
        ))}
      </div>
    </div>

      <footer className="footer" style={{ marginLeft: 0 }}>
        <div className="footer-container">

          <div className="footer-section">
            <h2 className="footer-title">Jeyam<sup>®</sup></h2>
            <div onClick={() => { navigate('/about'); setMobileMenuOpen(false); }} className="logo" style={{ cursor: 'pointer' }}>
              <img src="/images/footerlogo.png" className="footer-img" alt="Jeyam Logo" />
            </div>
            <p className="footer-subtext">Global Goods, Tailored Solutions. Redefining<br></br> Export for the Modern World.</p>
          </div>

          <div className="footer-section">
            <h3 className="footer-heading">Company Info</h3>
            <p>Email Support - <a href="mailto:info@jeyamfoods.com">info@jeyamfoods.com</a></p>
            <p>Contact Number - +91 9843156891</p>
            <p>Address - 5/206, H3, Tiruchendur Road, Opp. Spic Nagar,Muthunagar Medical Complex, Muthiahpuram,</p>
            <p>Thoothukudi - 628005. Tamilnadu, India.</p>
          </div>

          <div className="footer-section">
            <h3 className="footer-heading">Customer Care</h3>
            <ul className="footer-links">
              {/* <li><a href="#">FAQ</a></li>
              <li><a href="#">Track Your Order</a></li>
              <li><a href="#">Shipping Policy</a></li>
              <li><a href="#">Refund Policy</a></li> */}
              <li><Link to="/shippingpolicy">Shipping & Payment Policy</Link></li>
            </ul>
          </div>

        </div>

        <div className="footer-bottom">
          © 2025 Jeyam Foods, All rights reserved. Powered by{' '}
          <a href="https://www.evalbench.com/" target="_blank" rel="noopener noreferrer">
            Evalbench
          </a>
        </div>
        <a
      href="https://wa.me/919843156891"
      className="whatsapp-float"
      target="_blank"
      rel="noopener noreferrer"
    >
      <i className="fab fa-whatsapp"></i>
    </a>
      </footer>
    </div>
  );
};

export default Footer;
